import { SupportLibConfig } from "@support/bp-pf-support";
import { environment } from "../../../../environments/environment";

export const supportLibConfig: SupportLibConfig = {
  apiUrl: environment.platformSupportUrl,
  appId: environment.app_id,
  defaultTab: 'faq'
};